import React from 'react';
import SelectField from './SelectField';
import NormalInput from './NormalInput';
import CenteredLoader from './Loader';

/**
 * Component used to filter data on tables
 * author: issam@abweb.ma
 * @param {Object} selectProps, props for the SelectField Comp
 * @param {Object} searchProps, props for the NormalInput Comp
 * @param {Boolean} hideSelect, it does exactly what it says
 */
const FilterSearch = ({ selectProps, searchProps, hideSelect, loading }) => {
  // if loading is true, return a spinner
  if(loading) {
    return <CenteredLoader noPadding />
  }
  // else return the comp 
  return (
    <div className="tw-filter-search">
      {!hideSelect && (
        <SelectField
          placeholder="Selectioner"
          className="tw-filter-search-select"
          type="filter"
          {...selectProps}
        />
      )}
      <NormalInput
        className="tw-filter-search-input"
        isFilter
        placeholder="Chercher..."
        icon="mdi-magnify mdi-24px mdi-flip-h"
        {...searchProps}
      />
    </div>
  );
};

export default FilterSearch;
